import { useState } from "react";
import { Box, Typography, TextField, SelectChangeEvent } from "@mui/material";
import { initialParamData, ParamData } from "../../../types/Param";
import SucceededFailedLogin from "./SucceededFailedLogin";

const SucceededFailedLoginCard = () => {
  const [paramData, setParamData] = useState<ParamData>(initialParamData);

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent
  ) => {
    const { name, value } = e.target;

    setParamData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Box
      sx={{
        bgcolor: "white",
        p: 2,
        borderRadius: 2,
        boxShadow: 2,
        minHeight: 180,
      }}
    >
      <Typography variant="subtitle1" fontWeight="bold" mb={2}>
        Succeeded vs Failed Login
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <TextField
          type="date"
          name="startingFrom"
          label="Start Date"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={paramData.startingFrom}
          onChange={handleChange}
          sx={{
            width: { xs: "100%", sm: "45%" },
          }}
        />

        <TextField
          type="date"
          name="endingOn"
          label="End Date"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={paramData.endingOn}
          onChange={handleChange}
          sx={{
            width: { xs: "100%", sm: "45%" },
          }}
        />
      </Box>

      <SucceededFailedLogin data={paramData} />
    </Box>
  );
};

export default SucceededFailedLoginCard;
